import {md5} from "@pg-mono/string-utils";
import {sessionCache} from "@pg-rp/session-cache";

import {getClientAnalyticsSessionId} from "./get_client_analytics_session_id";
import {getOfferListingAmplitudeItemListContextKey} from "./get_offer_listing_amplitude_item_list_context_key";
import {ITEM_LIST_IDS_SESSION_STORAGE_KEY} from "./offer_listing_amplitude_item_list_storage_keys";
import {OfferListingItemListQuery} from "./types";

export const getOrCreateOfferListingAmplitudeItemListId = (query: OfferListingItemListQuery, now = Date.now()): string | undefined => {
    const analyticsSessionId = getClientAnalyticsSessionId();

    if (!analyticsSessionId) {
        return undefined;
    }

    const contextKey = getOfferListingAmplitudeItemListContextKey(query, analyticsSessionId);
    const existingIds = readStoredItemListIds();
    const existingId = existingIds[contextKey];

    if (existingId) {
        return existingId;
    }

    const nextId = `${Math.floor(now / 1000)}_${md5(contextKey)}`;
    writeStoredItemListIds({
        ...existingIds,
        [contextKey]: nextId
    });

    return nextId;
};

const readStoredItemListIds = (): Record<string, string> => {
    return sessionCache.get<Record<string, string>>(ITEM_LIST_IDS_SESSION_STORAGE_KEY) ?? {};
};

const writeStoredItemListIds = (value: Record<string, string>) => {
    sessionCache.set(ITEM_LIST_IDS_SESSION_STORAGE_KEY, value);
};
import {md5} from "@pg-mono/string-utils";
import {sessionCache} from "@pg-rp/session-cache";

import {getClientAnalyticsSessionId} from "./get_client_analytics_session_id";
import {getOfferListingAmplitudeItemListContextKey} from "./get_offer_listing_amplitude_item_list_context_key";
import {ITEM_LIST_IDS_SESSION_STORAGE_KEY} from "./offer_listing_amplitude_item_list_storage_keys";
import {OfferListingItemListQuery} from "./types";

export const getOrCreateOfferListingAmplitudeItemListId = (query: OfferListingItemListQuery, now = Date.now()): string | undefined => {
    const analyticsSessionId = getClientAnalyticsSessionId();

    if (!analyticsSessionId) {
        return undefined;
    }

    const contextKey = getOfferListingAmplitudeItemListContextKey(query, analyticsSessionId);
    const existingIds = readStoredItemListIds();
    const existingId = existingIds[contextKey];

    if (existingId) {
        return existingId;
    }

    const nextId = `${Math.floor(now / 1000)}_${md5(contextKey)}`;
    writeStoredItemListIds({
        ...existingIds,
        [contextKey]: nextId
    });

    return nextId;
};

const readStoredItemListIds = (): Record<string, string> => {
    return sessionCache.get<Record<string, string>>(ITEM_LIST_IDS_SESSION_STORAGE_KEY) ?? {};
};

const writeStoredItemListIds = (value: Record<string, string>) => {
    sessionCache.set(ITEM_LIST_IDS_SESSION_STORAGE_KEY, value);
};
